import { render } from "./ContentEditableComponent.vue?vue&type=template&id=12ed97d7"
import script from "./ContentEditableComponent.vue?vue&type=script&lang=js"
export * from "./ContentEditableComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__